const projectData = [
    {
        "id" : "1",
        "name" : "Chimeras",
        "desc" : "The Chimeras Game is an entertainment Metaverse taking on the mantle of solving the issues...",
    },
    {
        "id" : "2",
        "name" : "Chimeras",
        "desc" : "The Chimeras Game is an entertainment Metaverse taking on the mantle of solving the issues...",
    },
    {
        "id" : "3",
        "name" : "Chimeras",
        "desc" : "The Chimeras Game is an entertainment Metaverse taking on the mantle of solving the issues...",
    },
    {
        "id" : "4",
        "name" : "Chimeras",
        "desc" : "The Chimeras Game is an entertainment Metaverse taking on the mantle of solving the issues...",
    },
    {
        "id" : "5",
        "name" : "Chimeras",
        "desc" : "The Chimeras Game is an entertainment Metaverse taking on the mantle of solving the issues...",
    },
    {
        "id" : "6",
        "name" : "Chimeras",
        "desc" : "The Chimeras Game is an entertainment Metaverse taking on the mantle of solving the issues...",
    }
]

export default projectData;